import { Button, Input, List, Modal } from "semantic-ui-react";
import { settlePayment } from "services/payment";

export const SettlementPopup = (props: any): JSX.Element => {
  const {
    popup,
    setPopup,
    loading,
    setLoading,
    Payment,
    fetchCount,
    setFetchCount,
    selectedRecords,
    setSelectedRecords,
  } = props;

  return (
    <Modal
      closeIcon
      style={{ width: "25rem" }}
      onClose={() => setPopup({ ...popup, settlement: false })}
      open={popup.settlement}
    >
      <Modal.Header className="text-left">
        <div>Settlement</div>
      </Modal.Header>
      <Modal.Content className="text-left">
        <div>You are about to settle the checked records.</div>
      </Modal.Content>
      <Modal.Actions>
        <Button
          color="black"
          onClick={() => setPopup({ ...popup, settlement: false })}
        >
          Cancel
        </Button>
        <Button
          content="settlement"
          loading={loading}
          disabled={loading}
          onClick={async () => {
            try {
              setLoading((loading: boolean) => true);
              await settlePayment({
                selectedRecords,
              });
              setLoading((loading: boolean) => false);
              setPopup({ ...popup, settlement: false });
              setSelectedRecords([]);
            } catch (err) {
              setLoading((loading: boolean) => false);
              console.log("settlement error:", err);
            }
          }}
          color="red"
        />
      </Modal.Actions>
    </Modal>
  );
};
